import { httpRequest } from "@services/http";
import type { NetworkTemplate } from "@models/networkTemplate.model";

export interface ImportNetworkTemplatePayload {
  network: string;
  name: string;
  network_resource_id: number;
  source_campaign_id?: string;
}

export class CommandImportNetworkTemplate {
  async run(payload: ImportNetworkTemplatePayload): Promise<NetworkTemplate> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_templates/import/`;
    return await httpRequest<NetworkTemplate>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  }
}
